export const types = {
    SET_GET_PARTNERS: '[ROLE] SET GET PARTNERS',
    SET_GET_PARTNERS_BY_ID: '[ROLE] SET GET PARTNERS BY ID'
}